import { useTranslation } from 'react-i18next'

type SetCounterPillsProps = {
  totalSets: number
  completedSets: number
}

export function SetCounterPills({ totalSets, completedSets }: SetCounterPillsProps) {
  const { t } = useTranslation()

  if (totalSets <= 0) return null

  return (
    <div className="mt-3 grid grid-cols-3 gap-2">
      {Array.from({ length: totalSets }, (_, i) => {
        const setNumber = i + 1
        const isCompleted = completedSets >= setNumber
        const isCurrent = completedSets + 1 === setNumber

        return (
          <div
            key={setNumber}
            className={`rounded-xl border p-2 text-center transition-all ${
              isCompleted
                ? 'border-kilo-accent/30 bg-kilo-accent/10'
                : isCurrent
                  ? 'border-neutral-600 bg-neutral-800'
                  : 'border-neutral-800 bg-neutral-900'
            }`}
          >
            <p
              className={`text-xs font-medium ${
                isCompleted ? 'text-kilo-accent' : isCurrent ? 'text-white' : 'text-neutral-600'
              }`}
            >
              {t('coach.dashboard.setPill', { n: setNumber })}
            </p>
            <p
              className={`mt-0.5 text-[10px] ${
                isCompleted ? 'text-kilo-accent/70' : isCurrent ? 'text-neutral-400' : 'text-neutral-700'
              }`}
            >
              {isCompleted
                ? t('coach.dashboard.setPillDone')
                : isCurrent
                  ? t('coach.dashboard.setPillTap')
                  : t('coach.dashboard.setPillUpcoming')}
            </p>
          </div>
        )
      })}
    </div>
  )
}

export default SetCounterPills
